export default __webpack_public_path__ + "static/media/aboutImg.5d18098d.jpg";